import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UserProxyService } from '../../infrastructure/lobby-proxy/lobby-proxy-user/user-proxy.service';
import { UserProfile } from 'src/app/core/models/user/user-profile.model';
import { mapUserDtoToUserProfile } from '../mappings/user-model-dto/user-profile-dto.mapping';
import { throwIfLobbyErrorCode } from '../utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private readonly userProxyService: UserProxyService) { }

  loadUser(): Observable<UserProfile> {
    return this.userProxyService.getCurrentUser$().pipe(
      throwIfLobbyErrorCode,
      map(dto => dto.data),
      mapUserDtoToUserProfile
    )
  }

}
